const PATH = 'fe.components.measure.home.filters.filters_catalog';

const messages = {
  filters: {
    key: `${PATH}.filters`,
    defaultValue: 'Filters: '
  },
  formal: {
    key: `${PATH}.formal`,
    defaultValue: 'Formal'
  },
  informal: {
    key: `${PATH}.informal`,
    defaultValue: 'Informal'
  }
};

export default messages;
